import { render, staticRenderFns } from "./UserPhoneBindLeft.vue?vue&type=template&id=b79b6f16&scoped=true&"
import script from "./UserPhoneBindLeft.vue?vue&type=script&lang=js&"
export * from "./UserPhoneBindLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b6f16",
  null
  
)

export default component.exports